var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q10__page my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__title_head"},[_c('article-title-head',{attrs:{"options":{
                    category: _vm.currentPage.content.oTitleHead_sCategory.text,
                    phrase: _vm.currentPage.content.oTitleHead_sPhrase.text,
                    author: _vm.currentPage.content.oTitleHead_sAuthor.text,
                    from: _vm.currentPage.content.oTitleHead_nFrom.text,
                    to: _vm.currentPage.content.oTitleHead_nTo.text,
                    color: 'text-selective_green',
                }}})],1),_c('div',{staticClass:"q10__article_container__content"},[_c('div',{staticClass:"\n                    q10__article_container__content__vertical_head\n                    mx-auto\n                    relative\n                "},[_c('div',{staticClass:"relative"},[_c('article-vertical-head',{attrs:{"options":{
                            text: _vm.currentPage.content.oVerticalHead_sText
                                .text,
                            position: 'lg:ml-2 2xl:-ml-8',
                            imageAuthor:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image1.src,
                        }}}),_c('hotspot-richmedia',{staticClass:"top-6 right-1 lg:right-6",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Interview de M. Robino'
                            ),
                        }}})],1)]),_c('div',{staticClass:"q10__article_container__content__paragraphs"},[_c('paragraph-first-letter-big',{attrs:{"options":{
                        letter: _vm.currentPage.content.firstParagraph.text.substr(
                            0,
                            1
                        ),
                        color: 'text-selective_green',
                    }}}),_c('paragraph',{attrs:{"options":{}}},[_c('span',{domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.firstParagraph.text.slice(1)
                        )}})])],1)])]),_c('div',{staticClass:"relative"},[_c('timeline-carousel',{attrs:{"options":{
            timeline: _vm.currentPage.timeline,
        }}}),_c('hotspot-richmedia',{staticClass:"top-2 left-16",attrs:{"options":{
                icon: 'diaporama',
                collection: _vm.getRichmediaByCollection(
                    _vm.currentPage,
                    'Projet national MRCD'
                ),
            }}})],1),_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                    image:
                        'pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.image2.src,
                    descriptions: [
                        {
                            text: _vm.currentPage.images.image2.text,
                            position: 'top-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        } ],
                }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection: _vm.getRichmediaByCollection(
                        _vm.currentPage,
                        'SuPerHydro, témoignage de O. Guilhem'
                    ),
                }}})],1),_c('article-note',{attrs:{"options":{
                verticalcontent: _vm.currentPage.content.verticalContent.text,
                title: _vm.currentPage.content.sTitle.text,
                content: _vm.currentPage.content.secondParagraph.text,
                color: {
                    verticalcontent: 'text-cornflower_blue',
                    title: 'text-selective_green',
                    content: 'text-nandor',
                },
                fontSize: {
                    verticalcontent: 'text-4xl md:text-3xl lg:text-4xl',
                    title: 'text-4xl md:text-3xl lg:text-4xl',
                    content: 'text-md md:text-xl lg:text-xl',
                },
                margin: {
                    verticalcontent: 'mt-1',
                }
            }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }